import { render, staticRenderFns } from "./EditTaskDialog.vue?vue&type=template&id=83275298&scoped=true"
import script from "./EditTaskDialog.vue?vue&type=script&lang=js"
export * from "./EditTaskDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83275298",
  null
  
)

export default component.exports